export default "__VITE_ASSET__BN4k9XWp__"